export const visit = (vm, at) => {
vm(require("marketplace-ui-common/lang/en.lyaml"));
vm(require("property-management-iframe/lang/en.lyaml"));
vm(require("UIComponents/lang/en.lyaml"));
at({ "en": { "marketplace-embed": { "card": { "certified": "HubSpot Certified", "installed": "Installed", "beta": "BETA", "providerName": "By {{ providerName }}", "learnMore": "Learn more" } } } });
};